import { render } from "./cssSeamlessScroll.vue?vue&type=template&id=72773174"
import script from "./cssSeamlessScroll.vue?vue&type=script&lang=js"
export * from "./cssSeamlessScroll.vue?vue&type=script&lang=js"

import "./cssSeamlessScroll.vue?vue&type=style&index=0&id=72773174&lang=css"
script.render = render

export default script